import { NavigationContainer } from "@react-navigation/native";
import { Home } from "../screens/Home";
import { Login } from "../screens/Login";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React, { useContext } from "react";
import GlobalContext from "../context/Global";
import OpenHouseDetails from "../screens/OpenHouseDetails";
import { OpenHouseCheckIn } from "../screens/OpenHouseCheckIn";
import { Unlock } from "../screens/Unlock";
import { AccountInformation } from "../screens/AccountInformation";
import { FormBuilder } from "../screens/FormBuilder";
import CreateOpenHouse from "../screens/CreateOpenHouse";

import ViewAllOpenHouses from "../components/OpenHouseList/ViewAllOpenHouses";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import EditOpenHouse from "../screens/EditOpenHouse";
import EndOpenHouse from "../modals/EndOpenHouse";
import { ActivityIndicator, Platform } from "react-native";
import { QrCheckIn } from "../screens/QrCheckIn";
import DownloadPrompt from "../screens/DownloadPrompt";
import OpenHouseAlreadyCompleted from "../screens/OpenHouseAlreadyCompleted";
import OpenHouseError from "../screens/OpenHouseError";
import scheme from "../app.config";
import Constants from "expo-constants";
import { View, Text } from "../components/Themed";
import { setCheckInKey } from "../services/openhouse";

const Router = ({ route, navigation }: any) => {
  const { signed } = useContext(GlobalContext);

  React.useEffect(() => {
    if (route.params?.id) {
      setCheckInKey(route.params.id);
      navigation.navigate("QrCheckIn", route.params);
    } else {
      if (signed) {
        if (Platform.OS === "web" && window.innerWidth < 767) {
          navigation.navigate("DownloadPrompt");
        } else {
          navigation.navigate("Home");
        }
      } else {
        if (Platform.OS === "web" && window.innerWidth < 767) {
          navigation.navigate("DownloadPrompt");
        } else {
          navigation.navigate("Login");
        }
      }
    }
  }, [route.params, signed, navigation]);

  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
      <ActivityIndicator size="large" color="#75c2c3" />
    </View>
  );
};

import { getNavigationPrefix } from "../utils/urls";

const NAVIGATION_PREFIX = getNavigationPrefix();

export const Navigation = () => {
  const { signed } = useContext(GlobalContext);
  const Stack = createNativeStackNavigator();

  const linking = {
    prefixes: [NAVIGATION_PREFIX, scheme.expo.scheme + "://"],
    config: {
      screens: {
        Router: {
          path: "",
          parse: {
            id: (id: string) => id,
            team: (team: string) => team,
            phone: (phone: string) => phone,
          },
        },
        Home: "home",
        CreateOpenHouse: "create",
        EditOpenHouse: "edit",
        EndOpenHouse: "end",
        ViewAllOpenHouses: "view-all",
        OpenHomeDetails: "details",
        OpenHouseCheckIn: "check-in",
        Unlock: "unlock",
        AccountInformation: "account",
        FormBuilder: "form",
        Login: "login",
        QrCheckIn: "qr-check-in",
        OpenHouseAlreadyCompleted: "already-completed",
        OpenHouseError: "error",
      },
    },
  };

  return (
    <GestureHandlerRootView>
      <NavigationContainer linking={linking}>
        <Stack.Navigator
          initialRouteName="Router"
          screenOptions={{
            header: () => null,
          }}
        >
          <Stack.Screen name="Router" component={Router} />
          {signed ? (
            <>
              {Platform.OS === "web" && window.innerWidth < 767 ? (
                <Stack.Screen
                  name="DownloadPrompt"
                  component={DownloadPrompt}
                />
              ) : (
                <>
                  <Stack.Screen
                    name="Home"
                    component={Home}
                    options={{
                      title: "Open Houses",
                      headerBackVisible: false,
                    }}
                  />
                  <Stack.Screen
                    name="CreateOpenHouse"
                    component={CreateOpenHouse}
                    options={{
                      presentation:
                        Platform.OS === "web" ? "transparentModal" : "modal",
                      contentStyle: { backgroundColor: "rgba(0,0,0,.8)" },
                    }}
                  />
                  <Stack.Screen
                    name="EditOpenHouse"
                    component={EditOpenHouse}
                    options={{
                      presentation:
                        Platform.OS === "web" ? "transparentModal" : "modal",
                      contentStyle: { backgroundColor: "rgba(0,0,0,.8)" },
                    }}
                  />
                  <Stack.Screen
                    name="EndOpenHouse"
                    component={EndOpenHouse}
                    options={{
                      presentation:
                        Platform.OS === "web" ? "transparentModal" : "modal",
                      contentStyle: { backgroundColor: "rgba(0,0,0,.8)" },
                    }}
                  />

                  <Stack.Screen
                    name="ViewAllOpenHouses"
                    component={ViewAllOpenHouses}
                  />
                  <Stack.Screen
                    name="OpenHomeDetails"
                    component={OpenHouseDetails}
                  />
                  <Stack.Screen
                    name="OpenHouseCheckIn"
                    options={{
                      title: "Open House Check In",
                    }}
                    component={OpenHouseCheckIn}
                  />
                  <Stack.Screen name="Unlock" component={Unlock} />
                  <Stack.Screen
                    name="AccountInformation"
                    component={AccountInformation}
                  />
                  <Stack.Screen name="FormBuilder" component={FormBuilder} />
                  <Stack.Screen name="QrCheckIn" component={QrCheckIn} />
                  <Stack.Screen
                    name="OpenHouseAlreadyCompleted"
                    component={OpenHouseAlreadyCompleted}
                    options={{
                      gestureEnabled: false,
                    }}
                  />
                  <Stack.Screen
                    name="OpenHouseError"
                    component={OpenHouseError}
                    options={{
                      gestureEnabled: false,
                    }}
                  />
                </>
              )}
            </>
          ) : !signed ? (
            <>
              {Platform.OS === "web" && window.innerWidth < 767 ? (
                <Stack.Screen
                  name="DownloadPrompt"
                  component={DownloadPrompt}
                />
              ) : (
                <Stack.Screen name="Login" component={Login} />
              )}
              <Stack.Screen name="QrCheckIn" component={QrCheckIn} />
              <Stack.Screen
                name="OpenHouseAlreadyCompleted"
                component={OpenHouseAlreadyCompleted}
                options={{
                  gestureEnabled: false,
                }}
              />
              <Stack.Screen
                name="OpenHouseError"
                component={OpenHouseError}
                options={{
                  gestureEnabled: false,
                }}
              />
            </>
          ) : (
            <>
              {Platform.OS === "web" && window.innerWidth < 767 ? (
                <Stack.Screen
                  name="DownloadPrompt"
                  component={DownloadPrompt}
                />
              ) : (
                <>
                  <Stack.Screen
                    name="Home"
                    component={Home}
                    options={{
                      title: "Open Houses",
                      headerBackVisible: false,
                    }}
                  />
                  <Stack.Screen
                    name="CreateOpenHouse"
                    component={CreateOpenHouse}
                    options={{
                      presentation:
                        Platform.OS === "web" ? "transparentModal" : "modal",
                      contentStyle: { backgroundColor: "rgba(0,0,0,.8)" },
                    }}
                  />
                  <Stack.Screen
                    name="EditOpenHouse"
                    component={EditOpenHouse}
                    options={{
                      presentation:
                        Platform.OS === "web" ? "transparentModal" : "modal",
                      contentStyle: { backgroundColor: "rgba(0,0,0,.8)" },
                    }}
                  />
                  <Stack.Screen
                    name="EndOpenHouse"
                    component={EndOpenHouse}
                    options={{
                      presentation:
                        Platform.OS === "web" ? "transparentModal" : "modal",
                      contentStyle: { backgroundColor: "rgba(0,0,0,.8)" },
                    }}
                  />

                  <Stack.Screen
                    name="ViewAllOpenHouses"
                    component={ViewAllOpenHouses}
                  />
                  <Stack.Screen
                    name="OpenHomeDetails"
                    component={OpenHouseDetails}
                  />
                  <Stack.Screen
                    name="OpenHouseCheckIn"
                    options={{
                      title: "Open House Check In",
                    }}
                    component={OpenHouseCheckIn}
                  />
                  <Stack.Screen name="Unlock" component={Unlock} />
                  <Stack.Screen
                    name="AccountInformation"
                    component={AccountInformation}
                  />
                  <Stack.Screen name="FormBuilder" component={FormBuilder} />
                  <Stack.Screen name="QrCheckIn" component={QrCheckIn} />
                  <Stack.Screen
                    name="OpenHouseAlreadyCompleted"
                    component={OpenHouseAlreadyCompleted}
                    options={{
                      gestureEnabled: false,
                    }}
                  />
                  <Stack.Screen
                    name="OpenHouseError"
                    component={OpenHouseError}
                    options={{
                      gestureEnabled: false,
                    }}
                  />
                </>
              )}
            </>
          )}
        </Stack.Navigator>
      </NavigationContainer>
    </GestureHandlerRootView>
  );
};
